import { __extends } from "tslib";
import { faArrowCircleLeft, faArrowCircleRight, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Collapse from "@kunukn/react-collapse";
import { ReportColumnType, } from "peekdata-datagateway-api-sdk";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { FilterControls } from "../FilterControls";
import { ReportOptionsList } from "../ReportOptionsList";
import { ReportTabs } from "../ReportTabs";
import { RowsLimitInput } from "../RowsLimitInput";
import { Spinner } from "../Spinner";
import { ViewDropDowns } from "../ViewDropDowns";
import { defaultRows, setRowsDefaultLimit, setRowsDefaultOffset, } from "../../constants/rows";
import { IDimension, IMetric, ISelectedNode, } from "../../models/node";
import { ITranslations } from "../../models/translations";
import { setPeekdataApi } from "../../services/api";
import { IAsyncState } from "../../state/action";
import { ILoadNodesPayloadRequest, ISelectNodePayload, ISortNodePayload, ISortOrderNodePayload, addDataModel, changeLimitRowsTo, changeStartWithRow, expandReportOptions, generateReportRequest, loadDataModelNames, loadDataModelNodes, loadReportRequest, selectDataModel, setTranslations, sortEnd, sortOrder, unselectDataModel, } from "../../state/actions";
import { IReportBuilderState } from "../../state/reducers";
import { ICompatibilityState } from "../../state/reducers/compatibility";
import { IReportOptionsState } from "../../state/reducers/reportOptions";
import { IRgb } from "../../utils/Color";
import { DataModelDropDown } from "../DataModelDropDown";
var ReportBuilder = (function (_super) {
    __extends(ReportBuilder, _super);
    function ReportBuilder(props) {
        var _this = _super.call(this, props) || this;
        _this.onDataModelChanged = function (payload) {
            var _a = _this.props, onDataModelChanged = _a.onDataModelChanged, onReportOptionsChange = _a.onReportOptionsChange, reportOptions = _a.reportOptions;
            onDataModelChanged(payload);
            if (!reportOptions.isReportOptionsOpen) {
                onReportOptionsChange();
            }
        };
        _this.renderDataModelDropDowns = function () {
            var _a = _this.props, scopeNames = _a.scopeNames, dataModelNames = _a.dataModelNames, selectedScope = _a.selectedScope, selectedDataModel = _a.selectedDataModel, onScopeChanged = _a.onScopeChanged, showScopesDropdown = _a.showScopesDropdown, showDataModelDropdown = _a.showDataModelDropdown, t = _a.t, request = _a.request, onSaveReportRequest = _a.onSaveReportRequest;
            return (React.createElement(DataModelDropDown, { scopeNames: scopeNames, dataModelNames: dataModelNames, selectedScope: selectedScope, selectedDataModel: selectedDataModel, showScopesDropdown: showScopesDropdown, showDataModelsDropdown: showDataModelDropdown, onScopeChanged: onScopeChanged, onDataModelChanged: _this.onDataModelChanged, t: t, request: request, onSaveReportRequest: onSaveReportRequest }));
        };
        _this.renderLoader = function () {
            var loader = _this.props.loader;
            if (!_this.isLoading()) {
                return null;
            }
            return loader;
        };
        _this.isLoading = function () {
            var _a = _this.props, dimensions = _a.dimensions, metrics = _a.metrics;
            return ((dimensions && dimensions.isFetching) || (metrics && metrics.isFetching));
        };
        _this.renderError = function () {
            var e = _this.getErrors();
            if (!e || e.length === 0) {
                return null;
            }
            var text = e.join("\n");
            return React.createElement("div", { className: "alert alert-danger" }, text);
        };
        _this.setInitialExpandState = function () {
            var onReportOptionsChange = _this.props.onReportOptionsChange;
            if (!_this.showRequestResults()) {
                onReportOptionsChange();
            }
        };
        _this.renderReportBuilderContent = function () {
            var selectedDataModel = _this.props.selectedDataModel;
            if (!selectedDataModel) {
                return null;
            }
            return (React.createElement(Fragment, null,
                React.createElement("div", { className: "rb-report-builder-flex" },
                    React.createElement("button", { className: "btn btn-default rb-report-options-toggle hidden-xs hidden-sm", style: {
                            position: "fixed",
                            bottom: 20,
                            zIndex: 2000,
                            height: 35,
                        }, onClick: function () {
                            return _this.setState({ showSidebar: !_this.state.showSidebar });
                        } },
                        React.createElement("strong", null, _this.state.showSidebar ? (React.createElement(React.Fragment, null,
                            React.createElement(FontAwesomeIcon, { icon: faArrowCircleRight }),
                            " Collapse sidebar")) : (React.createElement(React.Fragment, null,
                            React.createElement(FontAwesomeIcon, { icon: faArrowCircleLeft }),
                            " Expand sidebar")))),
                    _this.state.showSidebar && (React.createElement(Collapse, { className: "rb-report-option-content", overflowOnExpanded: true, isOpen: true },
                        _this.renderMetricsList(),
                        _this.renderDimensionsList(),
                        _this.renderFilters(),
                        _this.renderRowsLimit())),
                    React.createElement("div", { style: { paddingTop: 35 }, key: "rerender-key-" + _this.state.showSidebar },
                        _this.renderTabs(),
                        _this.renderViewDropDowns()))));
        };
        _this.renderDimensionsList = function () {
            var _a = _this.props, dimensions = _a.dimensions, selectedDimensions = _a.selectedDimensions, onOptionAdded = _a.onOptionAdded, onOptionSelected = _a.onOptionSelected, onOptionUnselected = _a.onOptionUnselected, onSortEnd = _a.onSortEnd, showDimensionsList = _a.showDimensionsList, t = _a.t;
            if (!showDimensionsList ||
                !dimensions ||
                !dimensions.data ||
                dimensions.data.length === 0) {
                return null;
            }
            return (React.createElement(ReportOptionsList, { options: dimensions.data, selectedOptions: selectedDimensions, optionType: ReportColumnType.dimension, listTitle: t.dimensionsListTitle, placeholder: t.dimensionPlaceholder, noResultsText: t.noDimensionsText, buttonTitle: t.addDimensionButtonText, onOptionAdded: onOptionAdded, onOptionSelected: onOptionSelected, onOptionUnselected: onOptionUnselected, onSortOrder: _this.onSortOrder, onSortEnd: onSortEnd, isOptional: true, t: t }));
        };
        _this.renderMetricsList = function () {
            var _a = _this.props, metrics = _a.metrics, selectedMetrics = _a.selectedMetrics, onOptionAdded = _a.onOptionAdded, onOptionSelected = _a.onOptionSelected, onOptionUnselected = _a.onOptionUnselected, onSortEnd = _a.onSortEnd, showMetricsList = _a.showMetricsList, t = _a.t;
            if (!showMetricsList ||
                !metrics ||
                !metrics.data ||
                metrics.data.length === 0) {
                return null;
            }
            return (React.createElement(ReportOptionsList, { options: metrics.data, selectedOptions: selectedMetrics, optionType: ReportColumnType.metric, listTitle: t.metricsListTitle, placeholder: t.metricPlaceholder, noResultsText: t.noMetricsText, buttonTitle: t.addMetricButtonText, onOptionAdded: onOptionAdded, onOptionSelected: onOptionSelected, onOptionUnselected: onOptionUnselected, onSortOrder: _this.onSortOrder, onSortEnd: onSortEnd, t: t }));
        };
        _this.onSortOrder = function (payload) {
            var _a = _this.props, onSortOrder = _a.onSortOrder, onGenerateReportRequest = _a.onGenerateReportRequest;
            onSortOrder(payload);
            onGenerateReportRequest();
        };
        _this.renderFilters = function () {
            var showFilters = _this.props.showFilters;
            if (!showFilters) {
                return null;
            }
            return React.createElement(FilterControls, null);
        };
        _this.renderRowsLimit = function () {
            var _a = _this.props, limitRowsTo = _a.limitRowsTo, startWithRow = _a.startWithRow, showRowsOffset = _a.showRowsOffset, showRowsLimit = _a.showRowsLimit, maxRowsLimit = _a.maxRowsLimit, t = _a.t;
            return (React.createElement(RowsLimitInput, { startWithRow: startWithRow, limitRowsTo: limitRowsTo, showRowsOffset: showRowsOffset, showRowsLimit: showRowsLimit, onStartWithRowChanged: _this.onChangeStartWithRow, onLimitRowsToChanged: _this.onChangeLimitRowsTo, maxRowsLimit: maxRowsLimit, t: t }));
        };
        _this.onChangeStartWithRow = function (rowsOffset) {
            var _a = _this.props, onChangeStartWithRow = _a.onChangeStartWithRow, onGenerateReportRequest = _a.onGenerateReportRequest;
            onChangeStartWithRow(rowsOffset);
            onGenerateReportRequest();
        };
        _this.onChangeLimitRowsTo = function (rowsLimit) {
            var _a = _this.props, onChangeLimitRowsTo = _a.onChangeLimitRowsTo, onGenerateReportRequest = _a.onGenerateReportRequest;
            onChangeLimitRowsTo(rowsLimit);
            onGenerateReportRequest();
        };
        _this.renderViewDropDowns = function () {
            var _a = _this.props, showRequestViewButton = _a.showRequestViewButton, showResponseViewButton = _a.showResponseViewButton, loader = _a.loader;
            if (!_this.showRequestResults()) {
                return null;
            }
            return (React.createElement(ViewDropDowns, { showRequestViewButton: showRequestViewButton, showResponseViewButton: showResponseViewButton, loader: loader, baseURL: _this.props.baseURL }));
        };
        _this.showRequestResults = function () {
            var request = _this.props.request;
            return (request &&
                ((request.metrics && request.metrics.length > 0) ||
                    (request.dimensions && request.dimensions.length > 0)));
        };
        _this.renderTabs = function () {
            var _a = _this.props, showDataTabs = _a.showDataTabs, showChart = _a.showChart, showDataTable = _a.showDataTable, defaultTab = _a.defaultTab, loader = _a.loader, chartColors = _a.chartColors, request = _a.request;
            if (!_this.showRequestResults()) {
                return null;
            }
            return (React.createElement(ReportTabs, { showDataTabs: showDataTabs, showChart: showChart && request.metrics.length > 0, showDataTable: showDataTable, defaultTab: defaultTab, loader: loader, chartColors: chartColors }));
        };
        var _a = _this.props, peekdataApi = _a.peekdataApi, translations = _a.translations, defaultRowsOffset = _a.defaultRowsOffset, defaultRowsLimit = _a.defaultRowsLimit, setTranslations = _a.setTranslations;
        _this.state = {
            showSidebar: true,
        };
        setPeekdataApi(peekdataApi);
        setTranslations(translations);
        setRowsDefaultOffset(defaultRowsOffset);
        setRowsDefaultLimit(defaultRowsLimit);
        return _this;
    }
    ReportBuilder.prototype.componentDidMount = function () {
        var _a = this.props, reportRequest = _a.reportRequest, onLoadReportRequest = _a.onLoadReportRequest, onChangeStartWithRow = _a.onChangeStartWithRow, onChangeLimitRowsTo = _a.onChangeLimitRowsTo, defaultRowsOffset = _a.defaultRowsOffset, defaultRowsLimit = _a.defaultRowsLimit;
        onChangeStartWithRow(defaultRowsOffset);
        onChangeLimitRowsTo(defaultRowsLimit);
        onLoadReportRequest(reportRequest);
        this.setInitialExpandState();
    };
    ReportBuilder.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, translations = _a.translations, peekdataApi = _a.peekdataApi, onLoadReportRequest = _a.onLoadReportRequest, reportRequest = _a.reportRequest, onChangeStartWithRow = _a.onChangeStartWithRow, onChangeLimitRowsTo = _a.onChangeLimitRowsTo, defaultRowsOffset = _a.defaultRowsOffset, defaultRowsLimit = _a.defaultRowsLimit, setTranslations = _a.setTranslations;
        var prevTranslations = prevProps && prevProps.translations;
        var prevPeekdataApi = prevProps && prevProps.peekdataApi;
        var prevReportRequest = prevProps && prevProps.reportRequest;
        var prevRowsOffset = prevProps && prevProps.defaultRowsOffset;
        var prevRowsLimit = prevProps && prevProps.defaultRowsLimit;
        if (prevRowsOffset !== defaultRowsOffset) {
            onChangeStartWithRow(defaultRowsOffset);
        }
        if (prevRowsLimit !== defaultRowsLimit) {
            onChangeLimitRowsTo(defaultRowsLimit);
        }
        if (prevTranslations !== translations) {
            setTranslations(translations);
        }
        if (prevPeekdataApi !== peekdataApi) {
            setPeekdataApi(peekdataApi);
        }
        if (prevReportRequest !== reportRequest) {
            onLoadReportRequest(reportRequest);
        }
    };
    ReportBuilder.prototype.render = function () {
        return (React.createElement("div", { className: "rb-report-builder-container" },
            this.renderError(),
            this.renderDataModelDropDowns(),
            React.createElement("div", { className: "rb-report-container" },
                this.renderLoader(),
                this.renderReportBuilderContent())));
    };
    ReportBuilder.prototype.getErrors = function () {
        var e = new Set();
        var _a = this.props, dimensions = _a.dimensions, metrics = _a.metrics, compatibility = _a.compatibility;
        var dimensionsError = dimensions && dimensions.error;
        if (dimensionsError) {
            e.add(dimensionsError);
        }
        var metricsError = metrics && metrics.error;
        if (metricsError) {
            e.add(metricsError);
        }
        var _b = this.props, scopeNames = _b.scopeNames, datamodelNames = _b.dataModelNames;
        if ((scopeNames && scopeNames.error) ||
            (datamodelNames && datamodelNames.error)) {
            e.add(scopeNames.error || datamodelNames.error);
        }
        if (compatibility && compatibility.error) {
            e.add(compatibility.error);
        }
        var _c = this.props, dataFull = _c.dataFull, dataOptimized = _c.dataOptimized, file = _c.file, select = _c.select;
        if ((dataFull && dataFull.error) ||
            (dataOptimized && dataOptimized.error) ||
            (file && file.error) ||
            (select && select.error)) {
            e.add(dataFull.error || dataOptimized.error || file.error || select.error);
        }
        return Array.from(e);
    };
    ReportBuilder.defaultProps = {
        loader: React.createElement(Spinner, null),
        showScopesDropdown: true,
        showDataModelDropdown: true,
        showDimensionsList: true,
        showMetricsList: true,
        showFilters: true,
        showRowsOffset: true,
        showRowsLimit: true,
        defaultRowsOffset: defaultRows.offset,
        defaultRowsLimit: defaultRows.limit,
        maxRowsLimit: 10000,
        showRequestViewButton: true,
        showResponseViewButton: true,
        showDataTabs: true,
        showChart: true,
        showDataTable: true,
        defaultTab: 0,
    };
    return ReportBuilder;
}(React.PureComponent));
var connected = connect(function (state) {
    var dimensions = state.dimensions, metrics = state.metrics, selectedDimensions = state.selectedDimensions, selectedMetrics = state.selectedMetrics, compatibility = state.compatibility, limitRowsTo = state.limitRowsTo, startWithRow = state.startWithRow, request = state.request, scopeNames = state.scopeNames, dataModelNames = state.dataModelNames, translations = state.translations, reportOptions = state.reportOptions, dataFull = state.dataFull, dataOptimized = state.dataOptimized, file = state.file, select = state.select;
    return {
        dimensions: dimensions,
        metrics: metrics,
        selectedDimensions: selectedDimensions,
        selectedMetrics: selectedMetrics,
        compatibility: compatibility,
        limitRowsTo: limitRowsTo,
        startWithRow: startWithRow,
        request: request,
        scopeNames: scopeNames && scopeNames.scopeNames,
        selectedScope: scopeNames && scopeNames.selectedScope,
        dataModelNames: dataModelNames && dataModelNames.dataModelNames,
        selectedDataModel: dataModelNames && dataModelNames.selectedDataModel,
        t: translations,
        reportOptions: reportOptions,
        dataFull: dataFull,
        dataOptimized: dataOptimized,
        file: file,
        select: select,
    };
}, function (dispatch) {
    return {
        onOptionAdded: function (payload) {
            return dispatch(addDataModel(payload));
        },
        onOptionSelected: function (payload) {
            return dispatch(selectDataModel(payload));
        },
        onOptionUnselected: function (payload) {
            return dispatch(unselectDataModel(payload));
        },
        onSortOrder: function (payload) {
            return dispatch(sortOrder(payload));
        },
        onSortEnd: function (payload) { return dispatch(sortEnd(payload)); },
        onChangeStartWithRow: function (payload) {
            return dispatch(changeStartWithRow(payload));
        },
        onChangeLimitRowsTo: function (payload) {
            return dispatch(changeLimitRowsTo(payload));
        },
        onScopeChanged: function (scope) { return dispatch(loadDataModelNames(scope)); },
        onDataModelChanged: function (payload) {
            return dispatch(loadDataModelNodes(payload));
        },
        onLoadReportRequest: function (reportRequest) {
            return dispatch(loadReportRequest(reportRequest));
        },
        onGenerateReportRequest: function () { return dispatch(generateReportRequest()); },
        setTranslations: function (translations) {
            return dispatch(setTranslations(translations));
        },
        onReportOptionsChange: function () { return dispatch(expandReportOptions()); },
    };
})(ReportBuilder);
export { connected as ReportBuilder };
